import template from './billable_events.edit.html'
import controller from './billable_events.edit.controller'
import './billable_events.edit.scss'

const billableEventsEditComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default billableEventsEditComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/billable_events/edit/billable_events.edit.component.js